// extracted by mini-css-extract-plugin
module.exports = {"root":"_7ckKk","ShinyMenuIButtonNSkin":"_3qUxf","shinyMenuIButtonNSkin":"_3qUxf","linkElement":"_13CEy","shade":"_2YEH9","label":"_1CKR-"};